export const PRICE_CHANGE_FILTER_OPTIONS_LIMIT = 100
export const PRICE_CHANGE_FILTER_OPTIONS_MAX_OFFSET = 500
export const PRICE_CHANGE_PAGE_SIZE = 20

export enum PricingNumericTypeValues {
  Percent = "%",
  Dollar = "$",
}

export enum PricingDialogs {
  SubmitPriceChange = "submitPriceChange",
  AddSpecialPrice = "addSpecialPrice",
}
